import React from "react";
import lucifur from "../lucifur.png";

const FrontPage = ({ wish }) => {
  return (
    <div className="front-page">
      <h1>{wish.comment}</h1>
      <div className="lintle-dog">
        <img src={lucifur} width={450} alt="luci the dog" />
      </div>
    </div>
  );
};

export default FrontPage;
